/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';

const MFFloatingAdvisorWidget = () => {

  return (

      <div
        className="
          fixed
          right-6
          top-[150px]
          z-50
          hidden
          xl:block
        "
      >

      <div
        className="
          w-[320px]
          rounded-[32px]
          overflow-hidden
          shadow-2xl
          border
          border-green-200
          bg-white
        "
      >

        {/* HEADER */}
        <div
          className="
            bg-gradient-to-br
            from-green-800
            via-green-700
            to-emerald-600
            p-8
            text-white
            relative
            overflow-hidden
          "
        >

          {/* GLOW */}
          <div
            className="
              absolute
              -top-10
              -right-10
              w-32
              h-32
              bg-white/10
              rounded-full
              blur-2xl
            "
          />

          {/* BRAND */}
          <div className="relative z-10">

            {/*<div*/}
            {/*  className="*/}
            {/*    w-16*/}
            {/*    h-16*/}
            {/*    rounded-2xl*/}
            {/*    bg-white*/}
            {/*    text-green-800*/}
            {/*    flex*/}
            {/*    items-center*/}
            {/*    justify-center*/}
            {/*    text-2xl*/}
            {/*    font-black*/}
            {/*    mb-5*/}
            {/*  "*/}
            {/*>*/}
            {/*  OA*/}
            {/*</div>*/}


            <div className="text-2xl font-black leading-tight mb-2">
              Orion Analytics
            </div>

            <div className="text-green-100 text-sm">
              AMFI Registered Mutual Fund Distributor
            </div>

          </div>

        </div>


        {/* BODY */}
        <div className="p-7">

          {/* ADVISOR */}
          <div className="mb-6">

            <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">
              Advisor
            </div>

            <div className="text-xl font-bold text-gray-900">
              Santosh Bag
            </div>

          </div>


          {/* ARN */}
          <div
            className="
              bg-green-50
              border
              border-green-100
              rounded-2xl
              p-4
              mb-4
            "
          >

            <div className="text-xs text-gray-500 mb-1">
              ARN Number
            </div>

            <div className="text-lg font-black text-green-800 tracking-wide">
              ARN-356349
            </div>

          </div>


          {/* EUIN */}
          <div
            className="
              bg-green-50
              border
              border-green-100
              rounded-2xl
              p-4
              mb-7
            "
          >

            <div className="text-xs text-gray-500 mb-1">
              EUIN
            </div>

            <div className="text-lg font-black text-green-800 tracking-wide">
              EUIN-E680000
            </div>

          </div>


          {/* CTA BUTTONS */}
          <div className="space-y-4">

            <a
              href="/mfpartners/"
              className="block"
            >
              <button
                className="
                  w-full
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  py-4
                  rounded-2xl
                  font-bold
                  text-base
                  transition-all
                  shadow-md
                "
              >
                Start SIP
              </button>
            </a>

            <a
              href="/mfe/"
              className="block mt-4"
            >
              <button
                className="
                  w-full
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  py-4
                  rounded-2xl
                  font-bold
                  text-base
                  transition-all
                  shadow-md
                "
              >
                Explore Funds
              </button>
            </a>

            <button
              className="
                  w-full
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  py-4
                  rounded-2xl
                  font-bold
                  text-base
                  transition-all
                  shadow-md
              "
            >
              Free Portfolio Review
            </button>

          </div>


          {/* FOOTER */}
          <div
            className="
              mt-7
              pt-2
              border-t
              text-xs
              text-gray-500
              leading-relaxed
            "
          >
            Mutual Fund investments are subject to market risks.
            Read all scheme related documents carefully before investing.
          </div>

        </div>

      </div>

    </div>
  );
};

export default MFFloatingAdvisorWidget;